var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3960_31048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2679 5C11.0377 3.66667 12.9623 3.66667 13.7321 5L20.6603 17C21.4301 18.3333 20.4678 20 18.9282 20H5.0718C3.5322 20 2.56995 18.3333 3.33975 17L10.2679 5Z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2143 8L13.0274 14.8727H11.2732L11.0815 8H13.2143ZM12.1503 17.94C11.834 17.94 11.5624 17.8282 11.3356 17.6045C11.1087 17.3777 10.9969 17.1061 11.0001 16.7898C10.9969 16.4766 11.1087 16.2082 11.3356 15.9846C11.5624 15.7609 11.834 15.6491 12.1503 15.6491C12.4538 15.6491 12.7206 15.7609 12.9507 15.9846C13.1807 16.2082 13.2974 16.4766 13.3005 16.7898C13.2974 17.0006 13.2414 17.1939 13.1328 17.3697C13.0274 17.5422 12.8884 17.6812 12.7158 17.7866C12.5433 17.8889 12.3548 17.94 12.1503 17.94Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3960_31048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e6f9ae7174281e9ad09e610acc1bdca0.svg";
export { ForwardRef as ReactComponent };